import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { format } from 'date-fns';
import { Calendar as Calendar$1 } from 'primereact/calendar';
import { forwardRef } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { Icon } from '../Icon/Icon.js';
import { InputWrapper } from '../InputWrapper/InputWrapper.js';

function getDefaultIconProps(props) {
  const applyDefaultSetting = props.showIcon === undefined;
  if (!applyDefaultSetting) {
    return {};
  }
  return {
    showIcon: true,
    icon: jsx(Icon, {
      name: "calendar_today"
    }),
    iconPos: 'right',
    panelClassName: 'icon-right'
  };
}
function CalendarComponent(props, ref) {
  var _a;
  const _b = getDefaultIconProps(props),
    {
      panelClassName
    } = _b,
    iconProps = __rest(_b, ["panelClassName"]);
  const {
      name,
      value,
      horizontal,
      labelClassName,
      onBlur: _,
      placeholder: placeholderProps,
      clearButtonClassName: clearButtonClassNameProps,
      todayButtonClassName: todayButtonClassNameProps,
      formatStr,
      onHide: onHideProp
    } = props,
    restProps = __rest(props, ["name", "value", "horizontal", "labelClassName", "onBlur", "placeholder", "clearButtonClassName", "todayButtonClassName", "formatStr", "onHide"]);
  const placeholder = placeholderProps || 'Select date';
  const clearButtonClassName = clearButtonClassNameProps || 'p-button-text';
  const todayButtonClassName = todayButtonClassNameProps || 'p-button-text';
  const defaultProps = {
    placeholder,
    clearButtonClassName,
    todayButtonClassName,
    showButtonBar: (_a = props.showButtonBar) !== null && _a !== void 0 ? _a : true
  };
  const formContext = useFormContext();
  const isControlled = typeof value !== 'undefined';
  if (isControlled || !formContext || !name) {
    return jsx(InputWrapper, Object.assign({}, props, {
      children: jsx(Calendar$1, Object.assign({
        ref: ref,
        name: name,
        invalid: props.invalid,
        required: props.required,
        panelClassName: panelClassName,
        dateFormat: "dd/mm/yy",
        hourFormat: "24",
        appendTo: "self",
        value: value ? new Date(value) : undefined,
        placeholder: placeholder
      }, restProps, iconProps, defaultProps, {
        onHide: onHideProp
      }))
    }));
  }
  function valueToDate(value) {
    if (!value) {
      return;
    }
    const convertedDate = new Date(value);
    if (isNaN(convertedDate.getTime())) {
      return;
    }
    return convertedDate;
  }
  return jsx(Controller, {
    name: name,
    control: formContext.control,
    rules: {
      required: props.required
    },
    render: _ref => {
      let {
        field,
        fieldState
      } = _ref;
      return jsx(InputWrapper, Object.assign({
        field: field,
        fieldState: fieldState,
        horizontal: horizontal,
        labelClassName: labelClassName
      }, props, {
        children: jsx(Calendar$1, Object.assign({
          panelClassName: panelClassName,
          dateFormat: "dd/mm/yy",
          hourFormat: "24",
          appendTo: "self",
          placeholder: placeholder
        }, field, restProps, iconProps, defaultProps, {
          invalid: fieldState.invalid,
          ref: ref,
          value: valueToDate((field === null || field === void 0 ? void 0 : field.value) || (props === null || props === void 0 ? void 0 : props.value)),
          onChange: e => {
            if (formatStr) {
              const formatted = e.value ? format(e.value, formatStr) : undefined;
              field.onChange(formatted);
              return;
            }
            field.onChange(e);
          },
          onHide: () => {
            field.onBlur();
            onHideProp === null || onHideProp === void 0 ? void 0 : onHideProp();
          }
        }))
      }));
    }
  });
}
const Calendar = /*#__PURE__*/forwardRef(CalendarComponent);

export { Calendar };
